import menuMidiImg from "@assets/images/scan-to/offers/menu_midi.jpg";
import happyHourImg from "@assets/images/scan-to/offers/happy_hour.jpg";
import dessertImg from "@assets/images/scan-to/offers/dessert.jpg";

import { OfferItem } from "./types";

export { LANGUAGE_CODES, SECTION_ICONS } from "../shared/constants";
export type { SectionIconEntry } from "../shared/constants";

// ─── Default section titles (multilingual) ─────────────
export const DEFAULT_SECTION_TITLES: Record<string, string> = {
    fr: "Offres du jour",
    en: "Offers of the day",
    ru: "Предложения дня",
    it: "Offerte del giorno",
    es: "Ofertas del día",
    pt: "Ofertas do dia",
    de: "Angebote des Tages",
    ar: "عروض اليوم",
};

// ─── Default offer images (local assets) ──────────────
export const DEFAULT_OFFER_IMAGES: Record<number, string> = {
    1: menuMidiImg,
    2: happyHourImg,
    3: dessertImg,
};

// ─── Default offers ────────────────────────────────────
export const DEFAULT_OFFERS: OfferItem[] = [
    {
        id: 1,
        order: 1,
        image: "",
        title: {
            fr: "Menu Découverte",
            en: "Discovery Menu",
            ru: "Меню открытий",
            it: "Menu Scoperta",
            es: "Menú Descubrimiento",
            pt: "Menu Descoberta",
            de: "Entdeckungsmenü",
            ar: "قائمة الاكتشاف",
        },
        description: {
            fr: "Entrée + Plat + Dessert + Vin inclus",
            en: "Starter + Main + Dessert + Wine included",
            ru: "Закуска + Основное + Десерт + Вино включены",
            it: "Antipasto + Piatto + Dolce + Vino incluso",
            es: "Entrada + Plato + Postre + Vino incluido",
            pt: "Entrada + Prato + Sobremesa + Vinho incluído",
            de: "Vorspeise + Hauptgericht + Dessert + Wein inklusive",
            ar: "مقبلات + طبق رئيسي + حلوى + نبيذ مشمول",
        },
        tag: "-20%",
        url: "",
        active: true,
    },
    {
        id: 2,
        order: 2,
        image: "",
        title: {
            fr: "Heure Heureuse",
            en: "Happy Hour",
            ru: "Счастливый час",
            it: "Ora Felice",
            es: "Hora Feliz",
            pt: "Hora Feliz",
            de: "Happy Hour",
            ar: "ساعة سعيدة",
        },
        description: {
            fr: "Cocktails à moitié prix 18h-20h",
            en: "Half-price cocktails 6pm-8pm",
            ru: "Коктейли за полцены 18-20",
            it: "Cocktail a metà prezzo 18-20",
            es: "Cócteles a mitad de precio 18h-20h",
            pt: "Cocktails a metade do preço 18h-20h",
            de: "Cocktails zum halben Preis 18-20 Uhr",
            ar: "كوكتيلات بنصف السعر 6-8 مساءً",
        },
        tag: "-50%",
        url: "",
        active: true,
    },
    {
        id: 3,
        order: 3,
        image: "",
        title: {
            fr: "Dessert Offert",
            en: "Free Dessert",
            ru: "Бесплатный десерт",
            it: "Dolce Offerto",
            es: "Postre Gratis",
            pt: "Sobremesa Grátis",
            de: "Gratis Dessert",
            ar: "حلوى مجانية",
        },
        description: {
            fr: "Pour toute commande supérieure à 25€",
            en: "For any order over €25",
            ru: "При заказе от 25€",
            it: "Per ogni ordine superiore a 25€",
            es: "Para pedidos superiores a 25€",
            pt: "Para encomendas superiores a 25€",
            de: "Bei Bestellungen über 25€",
            ar: "لأي طلب يتجاوز 25 يورو",
        },
        tag: "Offert",
        url: "",
        active: true,
    },
];
